
import { Box, Grid } from "@mui/material";
import { useUsuariosTodosRol } from "../../../hooks";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, TablaListadoUsuarios } from "../../components";





export const ListaUsuarios = () => {

    
    const { todoUsuariosQuery, page, chagePage, termino, chageTermino } = useUsuariosTodosRol(['SUPERADMIN', 'ADMIN'])


    return (

        <DisenioPaginas titulo="Listado de Administradores" url="add/user">
            <Grid container sx={{mt:3}}>
                {(todoUsuariosQuery.isLoading)
                ?   <CargandoMedio titulo="Cargando Usuarios..." />
                :   <>
                    <BuscadorSoloValor termino={ termino } chageTermino={chageTermino} 
                        titulo='Buscar usuario...' place='Buscar x nombre cedula o email...'
                    />
                    <TablaListadoUsuarios data={todoUsuariosQuery.data || []} chagePage={chagePage} page={page} />
                    </>
                }
            </Grid>
            <Box sx={{height:30}} />
        </DisenioPaginas>

    )
}
